import './AddToCart.css'

import { fireEvent, hide, show, ajaxPost } from '../../lib/jsfunc.js'
import { on, ready, query } from '../../lib/dom.js'

ready(function() {
  if ( !query('.AddToCart')) return false

  var inpAnzahl = query('.AddToCart form input.anzahl')
  if (inpAnzahl) {
    setTimeout(inpAnzahl.focus(), 0)

    on(inpAnzahl, 'change', function (event) {
      if (checkInput(event.target.value)) {
        changePreis(event)
      } else {
        setMinPreis()
      }
    })

    on(inpAnzahl, 'keyup', function (event) {
      fireEvent(event.target, 'change')
    })
    
    setMinPreis()
    inpAnzahl.value = ""
    fireEvent(inpAnzahl, 'change')
  }
})

function updatePreis(anzahl, data) {
  if (anzahl > 0) {
    query('.AddToCart tr.einzelpreis td span.einzelpreis').textContent = data['einzelpreis']
    query('.AddToCart tr.gesamtpreis td span.gesamtpreis').textContent = data['gesamtpreis']
    hide(query('.AddToCart tr.einzelpreis td span.ab'));
  }
}

function getPreis(elem) {
  var anzahl = parseInt(elem.value)
  if (anzahl > 0) {
    var url = elem.closest('tr').getAttribute('data-preisurl')
    ajaxPost(url, {'anzahl': anzahl }, function(request) {
      updatePreis(anzahl, JSON.parse(request.responseText))
    })
  }
}

function checkMindestmenge(anzahl) {
  var AddToCart = query('.AddToCart')
  if( !AddToCart) return false
  
  var trAnzahl = query(AddToCart, 'tr.anzahl')
  var verfuegbar = parseInt(trAnzahl.getAttribute('data-verfuegbar'))
  var mindestmenge = parseInt(trAnzahl.getAttribute('data-mindestmenge'))
  
  var trMindestmenge = query(AddToCart, 'tr.mindestmenge')
  var trMindestmengerange = query(AddToCart, 'tr.mindestmengerange')
  var tdVerfuegbar = query(AddToCart, 'tr.verfuegbar td')
  var submit = query(AddToCart, 'tr.submit input')
  
  if (mindestmenge > 0) {
    if (anzahl > verfuegbar && anzahl < mindestmenge) {
      if (trMindestmengerange) {
        trMindestmengerange.classList.add('error')
      }
      if (trMindestmenge) {
        trMindestmenge.classList.add('error')
      }
      if (tdVerfuegbar) {
        tdVerfuegbar.classList.add('error')
      }
      if (trAnzahl) {
        query(trAnzahl, 'input').classList.add('error')
      }
      if (submit) {
        submit.setAttribute('disabled','disabled')
        submit.classList.add('disabled')
      }
      return false
    } else {
      if (trMindestmengerange) {
        trMindestmengerange.classList.remove('error')
      }
      if (trMindestmenge) {
        trMindestmenge.classList.remove('error')
      }
      if (tdVerfuegbar) {
        tdVerfuegbar.classList.remove('error')
      }
      if (trAnzahl) {
        query(trAnzahl, 'input').classList.remove('error')
      }
      if (submit) {
        submit.classList.remove('disabled')
        submit.removeAttribute('disabled')
      }
    }
  }
}


function checkInput(anzahl) {
  var trAnzahl = query('.AddToCart tr.anzahl')
  var submit = query('.AddToCart tr.submit input')
  
  if ( !anzahl.match(/^-?\d+$/) || anzahl == 0) {
    if (trAnzahl) {
      query(trAnzahl, 'input').classList.add('error')
    }
    if (submit) {
      submit.setAttribute('disabled','disabled')
      submit.classList.add('disabled')
    }
    return false;
  } else {
    if (trAnzahl) {
      query(trAnzahl, 'input').classList.remove('error')
    }
    if (submit) {
      submit.classList.remove('disabled')
      submit.removeAttribute('disabled')
    }
  }
  return true;
}

function changePreis(event) {
  event.preventDefault()
  var anzahl = event.target.value
  show(query('.AddToCart table tr.gesamtpreis th'))
  show(query('.AddToCart table tr.gesamtpreis td'))
  checkMindestmenge(anzahl)
  getPreis(event.target)
  return true
}

function setMinPreis(){
  hide(query('.AddToCart tr.gesamtpreis th'))
  hide(query('.AddToCart tr.gesamtpreis td'))
  show(query('.AddToCart tr.einzelpreis td span.ab'))
  var einzelpreis = query('.AddToCart tr.einzelpreis td span.einzelpreis')
  einzelpreis.textContent = einzelpreis.getAttribute('data-min')
  return true;
}
